import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentBox } from '../../../../lib/components/compound/pages/contentBox';
import { useGroupContext } from './context';
import {
  useGroupSelectionColumns,
  useGroupMemberColumns
} from '../../../../lib/components/tables/employee/columns';
import { EmployeeGroupTable } from '../../../../lib/components/tables/employee/employeeGroupTable';

export const GroupsDataForm: FC = () => {
  const { t } = useTranslation();
  const {
    employeesInGroup,
    employeesNotInGroup,
    isLoadingInGroup,
    isFetchingInGroup,
    isLoadingNotInGroup,
    isFetchingNotInGroup,
    moveToGroup,
    moveMultipleToGroup,
    removeFromGroup,
    isNewlyAdded,
    isNewlyRemoved
  } = useGroupContext();

  const selectionColumns = useGroupSelectionColumns(moveToGroup);
  const memberColumns = useGroupMemberColumns(removeFromGroup);

  return (
    <ContentBox
      className="max-w-[1070px]"
      sidebarComponentWidth="68%"
      paddingRight={'0px'}
      sidebarComponent={
        <EmployeeGroupTable
          className="w-full min-w-0 h-full"
          data={employeesNotInGroup}
          columns={selectionColumns}
          isLoading={isLoadingNotInGroup}
          isFetching={isFetchingNotInGroup}
          columnVisibility={{
            location: false,
            department: false,
            cost_center: false,
            active_benefit: false,
            budget_exhausted: false,
            entry_date: false
          }}
          headline={t('company:EMPLOYEES_NOT_ASSIGNED')}
          onRowDoubleClick={(employee) => moveToGroup(employee.id ?? '')}
          getRowClassName={(employee) => (isNewlyRemoved(employee.id ?? '') ? 'oldRow' : '')}
          enableRowSelection
          onBulkAction={moveMultipleToGroup}
        />
      }
    >
      <EmployeeGroupTable
        className="w-full h-full"
        data={employeesInGroup}
        columns={memberColumns}
        isLoading={isLoadingInGroup}
        isFetching={isFetchingInGroup}
        columnVisibility={{
          member_groups: false,
          location: false,
          department: false,
          cost_center: false,
          active_benefit: false,
          budget_exhausted: false,
          entry_date: false
        }}
        headline={t('company:EMPLOYEES_ASSIGNED')}
        onRowDoubleClick={(employee) => removeFromGroup(employee.id ?? '')}
        getRowClassName={(employee) => (isNewlyAdded(employee.id ?? '') ? 'newRow' : '')}
      />
    </ContentBox>
  );
};
